module.exports = __webpack_public_path__ + "static/img/silkway.19a28f83.svg";